import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchApprovalList = createAsyncThunk("fetchApprovalList", async ({ page, limit, filters }) => {
	const formatDate = (date) => (date && date.isValid && date.isValid() ? date.format("YYYY-MM-DD") : "");

	const params = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: filters?.keyword ?? "",
		type: filters?.type ?? "",
		department_id: filters?.department_id ?? "",
		section_id: filters?.section_id ?? "",
		status_id: filters?.status_id ?? "",
		start_date: filters?.dateRange && filters.dateRange[0] ? formatDate(filters.dateRange[0]) : "",
		end_date: filters?.dateRange && filters.dateRange[1] ? formatDate(filters.dateRange[1]) : "",
	});

	try {
		const response = await axiosHttp.get(`approvals?${params}`);
		return response.data.data;
	} catch (error) {
		console.error("API Error:", error);
		throw error;
	}
});

const ApprovalRequestListSlice = createSlice({
	name: "ApprovalRequestListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchApprovalList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchApprovalList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.page;
			state.total = action.payload.total;
		});
		builder.addCase(fetchApprovalList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ApprovalRequestListSlice.reducer;
